import React from "react";
import { Tooltip } from "react-tooltip";
import { Loader, Button, Icon, ClassHelper } from "components/lib";
import Style from "./card.module.scss";

export function Card(props) {
  const cardStyle = ClassHelper(Style, {
    shadow: props.shadow,
    center: props.center,
    noPadding: props.noPadding,
    loading: props.loading,
    className: props.className,
    last: props.last,
    restrictWidth: props.restrictWidth,
  });

  const renderActions = () => {
    if (!props.actions) return null;

    return (
      <div className={Style.btns}>
        {props.actions.buttons.map((act, index) =>
          props.actions.typeView === "icons" ? (
            <button onClick={act.action} key={index} data-tooltip-id={`tooltip-${index}`} data-tooltip-content={act.name}>
              <Icon
                image={act.icon}
                color={act.iconColor || "#475569"}
                size={act.iconSize || props.size || 18}
              />
              <Tooltip id={`tooltip-${index}`} />
            </button>
          ) : (
            <Button
              iconColor={"light"}
              icon={act.icon}
              color={act.color}
              text={act.name}
              action={act.action}
              iconButton={true}
              xsmall
              iconSize={12}
              key={index}
              data-tooltip-id={`tooltip-${index}`}
              data-tooltip-content={act.name}
            />
          )
        )}
      </div>
    );
  };

  return (
    <section className={cardStyle}>
      {props.title && (
        <header className={`${Style.header} ${Style.itemsBlock}`}>
          <h1 className={Style.title}>{props.title}</h1>
          {renderActions()}
        </header>
      )}

      {props.loading ? <Loader /> : props.children}
    </section>
  );
}